import {sha1} from 'js-sha1';

export async function browserComputeSha1(file: File | Blob) {
    const hash = sha1.create();
    const chunkSize = 1024 * 1024; // 1MB
    const totalSize = file.size;
    let offset = 0;

    while (offset < totalSize) {
        const chunk = file.slice(offset, offset + chunkSize);
        const buffer = new Uint8Array(await chunk.arrayBuffer());
        hash.update(buffer);
        offset += chunkSize;
    }

    return {
        hash: hash.hex(),
        size: file.size,
    }
}
